var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C4.13401 1 1 4.13401 1 8ZM11.504 5.89996C11.504 5.71331 11.4295 5.53439 11.297 5.40296C11.1655 5.27044 10.9866 5.1959 10.8 5.1959C10.6133 5.1959 10.4344 5.27044 10.303 5.40296L6.59998 9.11296L5.69698 8.20296C5.51941 8.0254 5.26061 7.95605 5.01806 8.02104C4.77551 8.08603 4.58605 8.27549 4.52106 8.51804C4.45607 8.7606 4.52541 9.0194 4.70298 9.19696L6.10297 10.597C6.23441 10.7295 6.41333 10.804 6.59998 10.804C6.78662 10.804 6.96554 10.7295 7.09698 10.597L11.297 6.39696C11.4295 6.26552 11.504 6.0866 11.504 5.89996Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check-circle-filled.cc92838ed48b44510519b455e9a1b757.svg";
export { ForwardRef as ReactComponent };